import React from 'react';
import './SuccessfulPage.css';
import { PUBLIC_URL } from '../config';
import { useTranslation } from 'react-i18next';

const SuccessfulPage: React.FC = () => {
  const { t } = useTranslation();
  const handleStartClick = () => {
    window.location.href = `${PUBLIC_URL}/onboarding-finish`;
  };

  return (
    <div className="success-container">
      <div className="success-content">
        <h1 className="success-title">{t('successPage.header')}</h1>
        <p className="success-description">{t('successPage.description')}</p>
        <div className="illustration-container">
          <img
            src="/images/authentication.png"
            alt="authentication Illustration"
            className="person-image"
          />
        </div>
        <button className="start-button" onClick={handleStartClick}>
          {t('global.accept')}
        </button>
      </div>
    </div>
  );
};

export default SuccessfulPage;
